import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.local and fill in.',
  );
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'x-application-name': 'sega-scrap-spares',
    },
  },
});

export type Tables =
  | 'parent_sku'
  | 'child_sku'
  | 'child_sku_equivalence'
  | 'scrap_sku'
  | 'scrap_rate_history'
  | 'customer'
  | 'customer_address'
  | 'dsr_request'
  | 'inventory_stock'
  | 'vehicle_inbound'
  | 'vehicle_inbound_yield'
  | 'invoice'
  | 'invoice_line'
  | 'invoice_logistics'
  | 'invoice_hsn_summary'
  | 'payment'
  | 'approval_request'
  | 'audit_log'
  | 'app_user'
  | 'permission'
  | 'user_permission'
  | 'permission_preset'
  | 'permission_preset_item'
  | 'cash_drawer_eod'
  | 'location'
  | 'app_setting';
